import { render } from "./Email.vue?vue&type=template&id=2fcd0ec2&scoped=true"
import script from "./Email.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Email.vue?vue&type=script&charset=utf-8&lang=js"

import "./Email.vue?vue&type=style&index=0&id=2fcd0ec2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcd0ec2"]])

export default __exports__